import api from "./index.js";
if (typeof window !== "undefined") {
  if (window.VantaNext)
    throw new Error("VantaNext already loaded; include the bundle once");
  window.VantaNext = api;
}
